// extracted by mini-css-extract-plugin
export var description = "PageAbout-module--description--fAg-b";
export var intro = "PageAbout-module--intro--F4vee";
export var preamble = "PageAbout-module--preamble--43RXw";